module.exports = __webpack_public_path__ + "TestGenius1.4e6b6240b8945d34594d.eot";


//////////////////
// WEBPACK FOOTER
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/src/assets/icon/fonts/TestGenius1.eot?28wm7n
// module id = ../../../../../src/assets/icon/fonts/TestGenius1.eot?28wm7n
// module chunks = styles